import { ConfigForm as form, marshal } from './ConfigForm'

const provider = {
  label: 'Pocket',
  form,
  marshal 
}

export default provider
